/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { withTranslation } from "react-i18next";
import Fade from "react-reveal/Fade";

import * as S from "./styles";

export const Block = ({ title, content, t }) => {
    return (
        <S.Container>
            <Fade left>
                <S.Title style={{textAlign:'center', padding:5}}>{title}</S.Title>
                <S.TextWrapper>
                    <S.Content>{content}</S.Content>
                </S.TextWrapper>
            </Fade>
        </S.Container>
    );
};

// export default withTranslation()(Block);
